<template>
  <div id="PaShadowing">
      <v-expansion-panels v-if="savedSchool.pa_shadowing_required" focusable class="px-2 mt-3 ">
        <v-expansion-panel class="mt-2  "  >
          <v-expansion-panel-header  class="light-blue--text text--darken-4">
            <v-layout row align-center pb-0 >

                <v-icon v-if="hasPAShadowingHours" color="green" >mdi-check-circle</v-icon>
              <v-icon  v-else color="red" >mdi-check-circle</v-icon>
              <v-icon color="blue darken-3" class="ml-2">mdi-account-multiple</v-icon>
              <span class="ml-2 blue--text text--darken-3 font-weight-medium">PA Shadowing</span>
            </v-layout>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager class=" px-0 mx-0 pb-0 elevation-0 ">

            <v-card style="borderRadius:5px" class="innerCardCover elevation-0" outlined>
              <v-layout  v-if="hasPAShadowingHours" class="green pb-2 justify-center">
                  <span  class="white--text text-center mt-2"> PA Shadowing Hours Completed</span>
              </v-layout>
              <v-layout  v-else class="red pb-2 justify-center">
                  <span  class="white--text text-center mt-2" ><span v-if="minPAShadowingHours > 0">{{minPAShadowingHours - totalPaShadowingHours}} </span>PA Shadowing Hours Pending</span>
              </v-layout>

              <v-layout v-if="totalPaShadowingHours / minPAShadowingHours * 100 < '100'" mt-2 mx-2>
                  <v-progress-linear

                    color="red "
                    height="8"
                    :value="totalPaShadowingHours / minPAShadowingHours * 100 "
                    rounded
                  ></v-progress-linear>
                </v-layout>
              <v-tabs
                v-model="pashadowingHoursTab"
                background-color="transparent"
                color="basil"
                grow
                class="mt-3 px-2"
                hide-slider
                >
                <v-tab active-class="grey darken-2 white--text" style="marginLeft:0px;">
                  Required Hrs
                </v-tab>

                <v-tab active-class="primary white--text">
                <v-icon small class="mr-2" >mdi-account-circle</v-icon>
                  My Hours
                </v-tab>
              </v-tabs>

                <v-tabs-items v-model="pashadowingHoursTab">
                <!-- Required Hours Tab Item -->
                <v-tab-item class="pb-2">
                  <v-layout  v-if="savedSchool.pa_shadowing_required === true" mt-4 mb-2 column align-center justify-center>
                      <v-progress-circular  v-if="savedSchool.pa_shadowing_minimum_hours !== ''" :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium red--text" :class="{'green--text' : hasPAShadowingHours, 'red--text' : !hasPAShadowingHours}">{{savedSchool.pa_shadowing_minimum_hours}}</span></v-progress-circular>
                      <span v-if="savedSchool.pa_shadowing_minimum_hours === '' " class="  mb-0  body-1 font-weight-light ">No Specified Hours</span>
                      <span  v-if="savedSchool.pa_shadowing_minimum_hours !== ''" class="mt-1   font-weight-light">Hours</span>
                  </v-layout>
                </v-tab-item>

                <!-- My Hours Tab Item-->
                <v-tab-item class="pb-2">

                  <v-layout  mt-4 mb-2 column align-center justify-center>
                      <v-progress-circular   :width="3" size="80" :value=100 color="grey"> <span class="percentageValue headline font-weight-medium blue--text text--darken-3" >{{Math.round(totalPaShadowingHours)}}</span></v-progress-circular>
                      <span   class="mt-1   font-weight-light">My Hours</span>
                  </v-layout>



                </v-tab-item>
              </v-tabs-items>
              </v-card>

              <!-- PA Shadowing Notes -->
              <v-card v-if="savedSchool.paShadowingNotes" outlined class=" mt-4 mb-4">
                <v-layout align-center justify-center class=" pb-1" >
                  <v-icon small class="mr-2">mdi-message-text-outline</v-icon>
                  <span class="font-weight-light align-center">Additional Notes </span>
                </v-layout>
                <v-divider></v-divider>
                <v-card-text class="text-center">
                  <span>{{savedSchool.paShadowingNotes}}</span>
                </v-card-text>
              </v-card>




          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
  </div>
</template>

<script>
  import userMixins from '@/mixins/usersmixin'
  import checkPaShadowingMixin from '@/mixins/requirementchecks/checkpashadowingmixin'
  export default {
    mixins: [userMixins,checkPaShadowingMixin],
    props: ['savedSchool'],
    data() {
      return {
         pashadowingHoursTab: null,
      }
    },

  }
</script>

<style scoped>
.v-expansion-panel::before {
   box-shadow: 0 10px 20px -10px rgba(0,0,0,.19)  !important;
}
.innerCardCover {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
  border-radius: 5px;
  padding: 0;
  margin-top: 12px;
}



</style>



// WEBPACK FOOTER //
// src/components/Dashboard/SavedSchools/RequirementTracker/PaShadowing.vue